export default __webpack_public_path__ + "static/media/sablier.6d6361a8.svg";